import React from 'react'

const IconParagraph = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path
                d='M0.625 7.29007L3.31767 0.830067C3.34299 0.769336 3.38571 0.717457 3.44046 0.680965C3.49521 0.644473 3.55954 0.625 3.62533 0.625C3.69113 0.625 3.75546 0.644473 3.81021 0.680965C3.86496 0.717457 3.90768 0.769336 3.933 0.830067L6.625 7.29007'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.959 2.62329V7.28996'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.49512 5.29004H5.75645'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.6253 7.28996C12.914 7.28996 13.9587 6.24529 13.9587 4.95662C13.9587 3.66796 12.914 2.62329 11.6253 2.62329C10.3367 2.62329 9.29199 3.66796 9.29199 4.95662C9.29199 6.24529 10.3367 7.28996 11.6253 7.28996Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconParagraph
